import { render, staticRenderFns } from "./UiForm.vue?vue&type=template&id=5ebb4d92"
import script from "./UiForm.vue?vue&type=script&lang=js"
export * from "./UiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports